import { css } from 'lit';
export const ratingStyles = css`
    :host lr-rating-element {
        margin-left: -2px;
    }
`;
